export default {
  geolocation: {
    lat: '60.1699',
    lng: '24.9384',
    label: '00100 Helsinki',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
